module.exports = __webpack_public_path__ + "img/duigou@2x.eb3cbe6c.png";